import { useEffect, useState } from "react";
import Input from "../../extra/Input";
import SettingBox from "./SettingBox";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getSetting,
  updateSetting,
  handleToggleSwitch,
} from "../../store/setting/setting.action";
import { getWithdraw } from "../../store/withdraw/withdraw.action";
import Button from "../../extra/Button";

import { set } from "date-fns";
import InfoTooltip from "../../../Component/extra/InfoTooltip";
import { apiInstanceFetch } from "../../../util/api";
import {
  cashfreeContent,
  codContent,
  flutterWaveContent,
  googlePlayContent1,
  paypalContent,
  paystackContent,
  razorpayContent,
  stripeContent,
} from "../../../Component/extra/infoContent";
import ToggleSwitch from "../../extra/ToggleSwitch";
import { usePermission } from "../../../hooks/usePermission";
import PaymentRestrictionsDialog from "./PaymentRestrictionsDialog";

const PaymentSetting = (props) => {

  const { can } = usePermission();
  const canEdit = can("Setting", "Edit");

  const { setting } = useSelector((state) => state.setting);

  const dispatch = useDispatch();
  const [cancelOrderCharges, setCancelOrderCharges] = useState();
  const [adminCommissionCharges, setAdminCommissionCharges] = useState();
  const [razorPayId, setRazorPayId] = useState("");
  const [razorSecretKey, setRazorSecretKey] = useState(
    ""
  );
  const [razorPaySwitch, setRazorPaySwitch] = useState(false);
  const [razorpayIosEnabled, setRazorpayIosEnabled] = useState(false);
  const [stripePublishableKey, setStripePublishableKey] = useState(
    ""
  );
  const [stripeSecretKey, setStripeSecretKey] = useState(
    ""
  );
  const [stripeSwitch, setStripeSwitch] = useState(false);
  const [stripeIosEnabled, setStripeIosEnabled] = useState(false);
  const [flutterWaveSwitch, setFlutterWaveSwitch] = useState(false);
  const [flutterwaveIosEnabled, setFlutterwaveIosEnabled] = useState(false);
  const [googlePlayEnabled, setGooglePlayEnabled] = useState(false);
  const [googlePayIosEnabled, setGooglePayIosEnabled] = useState(false);
  const [isCashOnDelivery, setIsCashOnDelivery] = useState(false);
  const [flutterWaveId, setFlutterWaveId] = useState(
    ""
  );
  const [paystackAndroidEnabled, setPaystackAndroidEnabled] = useState(false);
  const [paystackIosEnabled, setPaystackIosEnabled] = useState(false);
  const [paystackPublicKey, setPaystackPublicKey] = useState(
    ""
  );
  const [paystackSecretKey, setPaystackSecretKey] = useState(
    ""
  );
  const [cashfreeAndroidEnabled, setCashfreeAndroidEnabled] = useState(false);
  const [cashfreeIosEnabled, setCashfreeIosEnabled] = useState(false);
  const [cashfreeClientId, setCashfreeClientId] =
    useState("");
  const [cashfreeClientSecret, setCashfreeClientSecret] = useState(
    ""
  );
  const [paypalAndroidEnabled, setPaypalAndroidEnabled] = useState(false);
  const [paypalIosEnabled, setPaypalIosEnabled] = useState(false);
  const [paypalClientId, setPaypalClientId] = useState("");
  const [paypalSecretKey, setPaypalSecretKey] = useState("");
  const [isCheckedOnce, setIsCheckedOnce] = useState(false);
  const [isPaymentAllowed, setIsPaymentAllowed] = useState(null);
  const [isPaymentCheckInProgress, setIsPaymentCheckInProgress] = useState(false);
  const [openPaymentRestrictionDialog, setOpenPaymentRestrictionDialog] = useState(false);

  // error

  const [error, setError] = useState({
    agoraKey: "",
    agoraCertificate: "",
    cancelOrderCharges: "",
    adminCommissionCharges: "",
    razorPayId: "",
    razorSecretKey: "",
    stripePublishableKey: "",
    stripeSecretKey: "",
    flutterWaveId: "",
  });

  useEffect(() => {
   
    dispatch(getSetting());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getWithdraw());
  }, [dispatch]);

  useEffect(() => {
    
    setCancelOrderCharges(setting?.cancelOrderCharges);
    setAdminCommissionCharges(setting?.adminCommissionCharges);
    // box 4
    setRazorPayId(setting?.razorPayId);
    setRazorSecretKey(setting?.razorSecretKey);
    setRazorPaySwitch(setting?.razorPaySwitch);
    setRazorpayIosEnabled(setting?.razorpayIosEnabled);
    // box 5
    setStripePublishableKey(setting?.stripePublishableKey);
    setStripeSecretKey(setting?.stripeSecretKey);
    setStripeSwitch(setting?.stripeSwitch);
    setStripeIosEnabled(setting?.stripeIosEnabled);

    // box 6

    setFlutterWaveSwitch(setting?.flutterWaveSwitch);
    setFlutterwaveIosEnabled(setting?.flutterwaveIosEnabled);
    setGooglePlayEnabled(setting?.googlePlayEnabled);
    setGooglePayIosEnabled(setting?.googlePayIosEnabled);
    setIsCashOnDelivery(setting?.isCashOnDelivery);
    setFlutterWaveId(setting?.flutterWaveId);
    setPaystackAndroidEnabled(setting?.paystackAndroidEnabled);
    setPaystackIosEnabled(setting?.paystackIosEnabled);
    setPaystackPublicKey(setting?.paystackPublicKey);
    setPaystackSecretKey(setting?.paystackSecretKey);
    setCashfreeAndroidEnabled(setting?.cashfreeAndroidEnabled);
    setCashfreeIosEnabled(setting?.cashfreeIosEnabled);
    setCashfreeClientId(setting?.cashfreeClientId);
    setCashfreeClientSecret(setting?.cashfreeClientSecret);
    setPaypalAndroidEnabled(setting?.paypalAndroidEnabled);
    setPaypalIosEnabled(setting?.paypalIosEnabled);
    setPaypalClientId(setting?.paypalClientId);
    setPaypalSecretKey(setting?.paypalSecretKey);
  }, [setting]);

  const handleSubmit = () => {
    if (
      !razorPayId ||
      !razorSecretKey ||
      !stripePublishableKey ||
      !stripeSecretKey ||
      !flutterWaveId
    ) {
      let error = {};

      if (!razorPayId) error.razorPayId = "RazorPay Id is requird!";
      if (!razorSecretKey)
        error.razorSecretKey = "RazorSecretKey Id is requird!";
      if (!stripePublishableKey)
        error.stripePublishableKey = "stripePublishableKey is required";
      if (!stripeSecretKey)
        error.stripeSecretKey = "stripeSecretKey is required";

      if (!flutterWaveId) error.flutterWaveId = "flutterWaveId is required";
      return setError({ ...error });
    } else {
      
      let settingData = {
        razorPayId,
        razorSecretKey,
        stripePublishableKey,
        stripeSecretKey,
        flutterWaveId,
        paystackPublicKey,
        paystackSecretKey,
        cashfreeClientId,
        cashfreeClientSecret,
        paypalClientId,
        paypalSecretKey,
      };

      props.updateSetting(settingData, setting?._id);
    }
  };

  const handleClick = (type) => {
    //Handle Update Switch Value
    
    if (!canEdit) return;
    if (isPaymentCheckInProgress === true) return;

    if (isCheckedOnce === true) {
      if (isPaymentAllowed === true) {
        return dispatch(handleToggleSwitch(setting?._id, type));
      } else {
        return setOpenPaymentRestrictionDialog(true);
      }
    }

    apiInstanceFetch
      .get(`setting/verifyItemPurchaseCode`)
      .then((res) => {
        const allowed =
          res?.status === true && res?.allowPaymentSettings === true;

        setIsCheckedOnce(true);
        setIsPaymentAllowed(allowed);
        setIsPaymentCheckInProgress(false);

        if (allowed === true) {
          return dispatch(handleToggleSwitch(setting?._id, type));
        } else {
          return setOpenPaymentRestrictionDialog(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsCheckedOnce(true);
        setIsPaymentAllowed(false);
        setIsPaymentCheckInProgress(false);
        return setOpenPaymentRestrictionDialog(true);
      });
    setIsPaymentCheckInProgress(true);
  };

  return (
    <>
      <div className="mainSettingBar" style={{ margin: "0px 15px" }}>
        <div className="settingBar ">
          <div className="settingHeader primeHeader">
            <div
              className="col-12 headname"
              style={{
                marginTop: "15px",
                marginBottom: "-5px",
                marginLeft: "0px",
              }}
            >
              Payment Setting{" "}
            </div>
          </div>
          <div className="settingMain">
            <div className="row">
              {/* Razor Payment Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                {/* 🔹 Title Right Side Tooltip */}
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Razor Payment Setting`}</div>
                  <InfoTooltip
                    title="Razor Payment Setting"
                    content={razorpayContent}
                  />
                </div>
                <Input
                  type={`text`}
                  label={`RazorPay Id`}
                  value={razorPayId}
                  newClass={`col-12`}
                  placeholder={`Enter You razorPayId....`}
                  errorMessage={error.razorPayId && error.razorPayId}
                  onChange={(e) => {
                    setRazorPayId(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        razorPayId: `razorPayId Is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        razorPayId: "",
                      });
                    }
                  }}
                />

                <Input
                  type={`text`}
                  label={`Razor Secret Key`}
                  value={razorSecretKey}
                  newClass={`col-12`}
                  placeholder={`Enter You RazorSecretKey....`}
                  errorMessage={error.razorSecretKey && error.razorSecretKey}
                  onChange={(e) => {
                    setRazorSecretKey(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        razorSecretKey: `Razor Secret Key Is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        razorSecretKey: "",
                      });
                    }
                  }}
                />

                {/* 🔹 Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={razorPaySwitch}
                      onClick={() => handleClick("razorPaySwitch")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      RazorPay (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={razorpayIosEnabled}
                      onClick={() => handleClick("razorpayIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      RazorPay (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Stripe Payment Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Stripe Payment Setting`}</div>
                  <InfoTooltip
                    title="Stripe Payment Setting"
                    content={stripeContent}
                  />
                </div>
                <Input
                  type={`text`}
                  label={`Stripe Publishable Key`}
                  value={stripePublishableKey}
                  newClass={`col-12`}
                  placeholder={`Enter You stripe....`}
                  errorMessage={
                    error.stripePublishableKey && error.stripePublishableKey
                  }
                  onChange={(e) => {
                    setStripePublishableKey(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        stripePublishableKey: `Stripe Publishable Key Is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        stripePublishableKey: "",
                      });
                    }
                  }}
                />

                <Input
                  type={`text`}
                  label={`Stripe Secret Key`}
                  value={stripeSecretKey}
                  newClass={`col-12`}
                  placeholder={`Enter You Stripe Secret Key....`}
                  errorMessage={error.stripeSecretKey && error.stripeSecretKey}
                  onChange={(e) => {
                    setStripeSecretKey(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        stripeSecretKey: `Stripe Secret Key Is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        stripeSecretKey: "",
                      });
                    }
                  }}
                />
                {/* 🔹 Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={stripeSwitch}
                      onClick={() => handleClick("stripeSwitch")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Stripe (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={stripeIosEnabled}
                      onClick={() => handleClick("stripeIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Stripe (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Paystack Payment Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Paystack Payment Setting`}</div>
                  <InfoTooltip
                    title="Paystack Payment Setting"
                    content={paystackContent}
                  />
                </div>
                <Input
                  type={`text`}
                  label={`Paystack Public Key`}
                  value={paystackPublicKey}
                  newClass={`col-12`}
                  placeholder={`Enter Paystack Public Key....`}
                  onChange={(e) => {
                    setPaystackPublicKey(e.target.value);
                  }}
                />
                <Input
                  type={`text`}
                  label={`Paystack Secret Key`}
                  value={paystackSecretKey}
                  newClass={`col-12`}
                  placeholder={`Enter Paystack Secret Key....`}
                  onChange={(e) => {
                    setPaystackSecretKey(e.target.value);
                  }}
                />

                {/* Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={paystackAndroidEnabled}
                      onClick={() => handleClick("paystackAndroidEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Paystack (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={paystackIosEnabled}
                      onClick={() => handleClick("paystackIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Paystack (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Cashfree Payment Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Cashfree Payment Setting`}</div>
                  <InfoTooltip
                    title="Cashfree Payment Setting"
                    content={cashfreeContent}
                  />
                </div>
                <Input
                  type={`text`}
                  label={`Cashfree Client Id`}
                  value={cashfreeClientId}
                  newClass={`col-12`}
                  placeholder={`Enter Cashfree Client Id....`}
                  onChange={(e) => {
                    setCashfreeClientId(e.target.value);
                  }}
                />

                <Input
                  type={`text`}
                  label={`Cashfree Client Secret`}
                  value={cashfreeClientSecret}
                  newClass={`col-12`}
                  placeholder={`Enter Cashfree Client Secret....`}
                  onChange={(e) => {
                    setCashfreeClientSecret(e.target.value);
                  }}
                />

                {/* Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={cashfreeAndroidEnabled}
                      onClick={() => handleClick("cashfreeAndroidEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Cashfree (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={cashfreeIosEnabled}
                      onClick={() => handleClick("cashfreeIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Cashfree (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Paypal Payment Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Paypal Payment Setting`}</div>
                  <InfoTooltip
                    title="Paypal Payment Setting"
                    content={paypalContent}
                  />
                </div>
                <Input
                  type={`text`}
                  label={`Paypal Client Id`}
                  value={paypalClientId}
                  newClass={`col-12`}
                  placeholder={`Enter Paypal Client Id....`}
                  onChange={(e) => {
                    setPaypalClientId(e.target.value);
                  }}
                />

                <Input
                  type={`text`}
                  label={`Paypal Secret Key`}
                  value={paypalSecretKey}
                  newClass={`col-12`}
                  placeholder={`Enter Paypal Secret Key....`}
                  onChange={(e) => {
                    setPaypalSecretKey(e.target.value);
                  }}
                />

                {/* Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={paypalAndroidEnabled}
                      onClick={() => handleClick("paypalAndroidEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Paypal (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={paypalIosEnabled}
                      onClick={() => handleClick("paypalIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Paypal (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Flutter Wave Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Flutter Wave Setting`}</div>
                  <InfoTooltip
                    title="Flutterwave Setting"
                    content={flutterWaveContent}
                  />
                </div>
                <Input
                  type={`text`}
                  label={`FlutterWave Id`}
                  value={flutterWaveId}
                  newClass={`col-12`}
                  placeholder={`Enter You FlutterWaveId....`}
                  errorMessage={error.flutterWaveId && error.flutterWaveId}
                  onChange={(e) => {
                    setFlutterWaveId(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        flutterWaveId: `flutterWaveId Is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        flutterWaveId: "",
                      });
                    }
                  }}
                />

                {/* 🔹 Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={flutterWaveSwitch}
                      onClick={() => handleClick("flutterWave")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      FlutterWave (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={flutterwaveIosEnabled}
                      onClick={() => handleClick("flutterwaveIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      FlutterWave (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Google Play Setting */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Google Play Setting`}</div>
                  <InfoTooltip
                    title="Google Play Setting"
                    content={googlePlayContent1}
                  />
                </div>

                {/* 🔹 Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={googlePlayEnabled}
                      onClick={() => handleClick("googlePlayEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Google Play (Android) (Enable/Disable)
                    </span>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={googlePayIosEnabled}
                      onClick={() => handleClick("googlePayIosEnabled")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">
                      Google Play (IOS) (Enable/Disable)
                    </span>
                  </div>
                </div>
              </SettingBox>

              {/* Cash On Delivery */}
              <SettingBox submit={(e) => handleSubmit(e)}>
                <div
                  className="col-12 mb-3"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div className="mainTitle w-100">{`Cash On Delivery`}</div>
                  <InfoTooltip
                    title="Cash On Delivery Setting"
                    content={codContent}
                  />
                </div>
                {/* 🔹 Switch Row */}
                <div
                  className="col-12 mb-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <ToggleSwitch
                      value={isCashOnDelivery}
                      onClick={() => handleClick("isCashOnDelivery")}
                      disabled={!canEdit}
                    />
                    <span className="fw-semibold">COD (Enable/Disable)</span>
                  </div>
                </div>
              </SettingBox>
            </div>
            <div className="row mt-3">
              <div className="col-12 d-flex justify-content-end">
                <Button
                  newClass={`whiteFont`}
                  btnName={`Submit`}
                  btnColor={`btnBlackPrime`}
                  style={{
                    width: "90px",
                    borderRadius: "6px",
                    color: "#fff",
                    backgroundColor: "#b93160",
                    marginBottom: "20px"
                  }}
                  onClick={(e) => handleSubmit(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <PaymentRestrictionsDialog
        open={openPaymentRestrictionDialog}
        onClose={() => setOpenPaymentRestrictionDialog(false)}
      />
    </>
  );
};

export default connect(null, {
  getSetting,
  updateSetting,
  handleToggleSwitch,
  getWithdraw,
})(PaymentSetting);
